function AddressInfo(data) {
    let address = data || {};
    this.streetAddress = address.streetAddress;
    this.streetAddress2 = address.streetAddress2;
    this.streetAddress3 = address.streetAddress3;
    this.postalCode = address.postalCode;
    this.addressLocality = address.addressLocality;
    this.addressCountry = address.addressCountry;
}
module.exports = AddressInfo;